<template>
  <div class="distance" :class="{ 'visible': toggleDistance, 'invisible': !toggleDistance }">
    <div v-if="val" class="mt-1">{{ val.km }} km</div>
  </div>
</template>

<script>
export default {
  name: 'Distance',
  props: {
    toggleDistance: {
      type: [String, Boolean],
      required: true
    },
    val: {
      type: [Object, Array],
      required: true
    }
  },
  watch: {
    // toggleDistance: function (newVal, oldVal) {
    // this.$l.info('distance', 'watch toggleDistance\nnewVal =', newVal)
    // console.log('distance', 'watch toggleDistance\noldVal =', oldVal)
    // console.log('distance', 'watch toggleDistance\nnewVal =', newVal)
    // },
    // val: function (newVal, oldVal) {
    // console.log('distance', 'watch val\noldVal =', oldVal)
    // console.log('distance', 'watch val\nnewVal =', newVal)
    // }
  }

}
</script>

<style lang="postcss" scoped>
.distance {
  @apply absolute -top-9 h-7 px-2 py-3;
  @apply flex flex-row items-center justify-around;
  @apply rounded-md bg-pink-800 bg-opacity-90;
  @apply font-bold text-lg text-pink-200;
  @apply z-20;
}
</style>
